export const TOGGLE_UC_INBOX = 'events/TOGGLE_UC_INBOX';

/**
 * @return {{type: string}}
 */
export const toggleUcInbox = () => ({ type: TOGGLE_UC_INBOX });
